import axios from 'axios';
import Vue from 'vue'

export default {

    getBlockedList(page, pageSize){

        return axios.get('/api/items/block/list', { params: {page: page, pageSize: pageSize}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
    deleteItemFromBlackList(ref) {
        return axios.delete(`/api/items/block/${ref}`)
            .then(response => {
                if (response.data) { 
                    Vue.prototype.$snotify.success("Article débloqué avec succès");
                    return response.data; 
                } else {
                    Vue.prototype.$snotify.error("Erreur lors du déblocage de l'article");
                }
            })
            .catch(error => {
                Vue.prototype.$snotify.error(error); 
            });
    },
    addItemToBlackList(itemId) {
        return axios.post(`/api/items/block/${itemId}`)
            .then(response => {
                if (response.data) {
                    Vue.prototype.$snotify.success("Article bloqué avec succès");
                    return response.data; 
                } else {
                    Vue.prototype.$snotify.error("Erreur lors du blocage de l'article");
                }
            })
            .catch(error => {
                Vue.prototype.$snotify.error(error); 
            });
    }

}

